import { costBreakdownV2WidgetTotalDataWithIdsSelector } from "./costBreakdownV2WidgetTotalDataWithIdsSelector";
import { RootState } from "../../../../../store";

export const costBreakdownV2WidgetTableDataCountSelector = (
  state: RootState,
  widgetId: string,
): number | undefined => {
  return costBreakdownV2WidgetTotalDataWithIdsSelector(state, widgetId)?.length;
};
